import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Button, Form, Col, Row, Modal } from 'react-bootstrap';
import moment from 'moment';
import { DataTable } from 'primereact/datatable';
import { Paginator } from 'primereact/paginator';
import { Column } from 'primereact/column';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import $ from 'jquery';

function IndoNepalMoneyTransfer() {
  const navigate = useNavigate();
  const currentUser = useSelector((state) => state.data);
  const [errors, setErrors] = useState(false);
  const [data, setData] = useState(false);
  const [commissionData, setCommissionData] = useState(false);
  const [kycData, setKYCData] = useState(false);
  const [senderData, setSenderData] = useState(false);
  const [receiverData, setReceiverData] = useState(false);
  const [processId, setProcessId] = useState('');
  const [transferData, setTransferData] = useState(false);
  const [partnerUniqueRefNo, setPartnerUniqueRefNo] = useState(false);
  const [tokenData, setTokenData] = useState(false);
  const [searchBy, setSearchBy] = useState("mobile");
  const [showModal, setShowModal] = useState(false);
  const [viewData, setViewData] = useState(false);
  const [addReceiverModal, setAddReceiverModal] = useState(false);
  const [viewIndex, setViewIndex] = useState(0);
  const [paymentMode, setPaymentMode] = useState(false);
  const [bankName, setBankName] = useState(false);
  const [bankBranchName, setBankBranchName] = useState(false);
  const [states, setStates] = useState(false);
  const [districts, setDistricts] = useState(false);
  const handleClose = () => {
    setShowModal(false);
    setViewData(false);
    setAddReceiverModal(false);
    setErrors(false);
    setProcessId("");
  }
  const handleShow = () => setShowModal(true);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    let jsonData = {};
    let errorData = {};
    Array.from(form.elements).forEach((item) => {
      if (item.name) {
        if (item.value == "" && item.getAttribute("requiredField")) {
          errorData[item.name] = [addSpaceBetweenCases(item.name)] + " is required";
        }
        jsonData[item.name] = item.value;
      }
    });
    jsonData['nationality'] = "Nepalese";
    jsonData['id_issue_place'] = "";
    if (Object.entries(errorData).length > 0) {
      setErrors(errorData);
    }
    else {
      try {
        if (!jsonData?.otp) {
          setSenderData(jsonData);
          const response = await axios.post('/v2/remittance/send/otp', {
            action: "CreateCustomer",
            mobile: jsonData?.mobile
          });
          const { status, process_id, message } = response.data;
          if (status) {
            setProcessId(process_id);
          }
          toast(message);
        }
        else {
          let data = { ...senderData, otp: jsonData?.otp, process_id: processId };
          const response = await axios.post('/v2/remittance/create/customer', data);
          const { status, message } = response.data;
          if (status) {
            setShowModal(false);
          }
          toast(message);
        }
      } catch (error) {
        if (error?.response?.data?.message) {
          toast(error.response.data.message);
        }
      }
    }
  };

  const addReceiverSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    let jsonData = {};
    let errorData = {};
    Array.from(form.elements).forEach((item) => {
      if (item.name) {
        if (item.value == "" && item.getAttribute("requiredField")) {
          errorData[item.name] = [addSpaceBetweenCases(item.name)] + " is required";
        }
        jsonData[item.name] = item.value;
      }
    });
    if (Object.entries(errorData).length > 0) {
      setErrors(errorData);
    }
    else {
      try {
        if (!jsonData?.otp) {
          setReceiverData(jsonData);
          const response = await axios.post('/v2/remittance/send/otp', {
            ...receiverData,
            action: "CreateReceiver",
            customer_id: data[0].customerId,
            mobile: data[0].mobile
          });
          const { status, process_id, message } = response.data;
          if (status) {
            setProcessId(process_id);
          }
          toast(message);
        }
        else {
          let getData = { ...receiverData, otp: jsonData?.otp, process_id: processId, customer_id: data[0].customerId, sender_mobile: data[0].mobile };
          const response = await axios.post('/v2/remittance/create/receiver', getData);
          const { status, message } = response.data;
          if (status) {
            toast(message);
            setAddReceiverModal(false);
          }
          else {
            toast(message);
            //setAddReceiverModal(false);
            setProcessId("");
          }
        }
      } catch (error) {
        if (error?.response?.data?.message) {
          toast(error.response.data.message);
        }
      }
    }
  };

  const handleViewData = (index) => {
    setViewIndex(index);
    setViewData(true);
  };

  const verifyKyc = async () => {
    try {
      const response = await axios.post('/v2/remittance/customer/ekycinitiate', { CustomerId: kycData?.customer?.CustomerId });
      const { StatusCode, ResponseMessage, Url, PartnerUniqueRefNo, tokenData } = response.data;
      if (StatusCode == "0") {
        toast(ResponseMessage);
      }
      else {
        setPartnerUniqueRefNo(PartnerUniqueRefNo);
        setTokenData(tokenData);
        window.open(Url, '_blank');
      }
    }
    catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  const transferAmountSubmit = async (e) => {
    e.preventDefault();
    try {
      const { transferAmount, remittanceReason, otp } = e.target;
      if (!otp) {
        let sendData = {
          action: "SendTransaction",
          amount: transferAmount.value,
          customer_id: data[0].customerId,
          payment_mode: data[0].receivers[viewIndex].PaymentMode,
          receiver_id: data[0].receivers[viewIndex].CustomerId,
          sender_mobile: data[0].mobile
        }
        const response = await axios.post('/v2/remittance/send/otp', sendData);
        const { status, process_id, message } = response.data;
        if (status) {
          setProcessId(process_id);
          setTransferData({ transferAmount: parseInt(transferAmount.value), remittanceReason: remittanceReason.value });
        }
        toast(message);
      }
      else {
        //let data = { ...senderData, otp: otp.value, process_id: processId };
        let transferAmountData = {
          account_number: data[0].receivers[viewIndex].AcNumber,
          account_type: null,
          bank_branch_id: data[0].receivers[viewIndex].BankBranchId,
          bank_name: data[0].receivers[viewIndex].BankName,
          branch_name: data[0].receivers[viewIndex].BankBranchName,
          collected_amount: (parseInt(commissionData?.ServiceCharge) + transferData?.transferAmount),
          customer_id: data[0]?.customerId,
          exchange_rate: 1.6,
          income_source: data[0]?.income_source,
          otp: otp.value,
          pay_amount: (1.6 * transferData?.transferAmount),
          pay_currency: "NPR",
          payment_mode: data[0].receivers[viewIndex].PaymentMode,
          payout_country: "Nepal",
          process_id: processId,
          receiver_address: data[0].receivers[viewIndex].Address,
          receiver_city: null,
          receiver_gender: data[0].receivers[viewIndex].Gender,
          receiver_id: data[0].receivers[viewIndex].ReceiverId,
          receiver_mobile: data[0].receivers[viewIndex].Mobile,
          receiver_name: data[0].receivers[viewIndex].Name,
          relectionship: data[0].receivers[viewIndex].Relationship,
          remittance_reason: transferData?.remittanceReason,
          send_amount: transferData?.transferAmount,
          send_currency: "INR",
          sender_address: data[0]?.address,
          sender_city: data[0]?.city,
          sender_district: data[0]?.district,
          sender_dob: data[0]?.date_of_birth,
          sender_employer: data[0]?.employer,
          sender_gender: data[0]?.gender,
          sender_id: data[0]?._id,
          sender_id_expiry_date: null,
          sender_id_issue_place: null,
          sender_id_number: data[0]?.id_number,
          sender_id_type: data[0]?.id_type,
          sender_mobile: data[0]?.mobile,
          sender_name: data[0]?.name,
          sender_nationality: data[0]?.nationality,
          sender_phone: null,
          sender_state: data[0]?.state,
          service_charge: commissionData?.ServiceCharge
        };
        const response = await axios.post('/v2/remittance/send/transaction', transferAmountData);
        const { status, message } = response.data;
        if (status) {
          //setShowModal(false);
          handleClose();
        }
        else {
          //setShowModal(false);
        }
        toast(message);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    const { search_by, id_number, mobile } = e.target;
    const isValid = /^\d{10}$/.test(mobile.value);
    if (!isValid) {
      setErrors({ mobile: "Mobile should be 10 number" });
    }
    else {
      setErrors(false);
      let data = {};
      let url = "";
      if (search_by.value == "id") {
        data = {
          type: "id_number",
          mobile: id_number.value
        };
        url = '/v2/remittance/search/customer/id_number';
      }
      else {
        data = {
          type: "mobile",
          mobile: mobile.value
        };
        url = '/v2/remittance/search/customer/mobile';
      }
      try {
        const response = await axios.post(url, data);
        const { status, message } = response.data;
        if (status) {
          setData(response.data.result);
        }
        else {
          if (message == "kyc_not_verified") {
            setKYCData({ customer: response.data.customer });
            setPartnerUniqueRefNo(false);
            setTokenData(false);
          }
          toast(message);
          setData(false);
        }
      } catch (error) {
        if (error?.response?.data?.message) {
          toast(error.response.data.message);
        }
      }
    }
  };

  const getStateData = async (e) => {
    deleteError(e);
    try {
      const response = await axios.post('/v2/remittance/get/states', { country: e.target.value });
      const { status } = response.data;
      if (status) {
        setStates(response.data.data);
      }
    }
    catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  const getDistrictData = async (e) => {
    deleteError(e);
    try {
      const response = await axios.post('/v2/remittance/get/district', { state: e.target.value });
      const { status } = response.data;
      if (status) {
        setDistricts(response.data.data);
      }
    }
    catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };
  const getData = async () => {
    try {
      const response = await axios.post('/v2/remittance/get/banks', { country: "Nepal" });
      const { status } = response.data;
      if (status) {
        setBankName(response.data.banks);
      }
    }
    catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };
  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (currentUser && currentUser.prabhuMoneyTransfer == false) {
      navigate('/admin/dashboard');
    }
  }, [currentUser]);

  const captureFinger = async (e) => {
    e.preventDefault();
    const { CustomerType, SourceIncomeType, AnnualIncome } = e.target;
    const finalUrl = "https://127.0.0.1:11100/rd/capture";
    const XML = `<?xml version="1.0"?> <PidOptions ver="1.0"> <Opts fCount="1" fType="2" iCount="0" pCount="0" pgCount="2" format="0"   pidVer="2.0" timeout="10000" pTimeout="20000" wadh="TF/lfPuh1n4ZY1xizYpqikIBm+gv65r51MFNek4uwNw=" posh="UNKNOWN" env="P" /> <CustOpts><Param name="mantrakey" value="" /></CustOpts> </PidOptions>`;
    try {
      $.ajax({
        type: "CAPTURE",
        async: false,
        crossDomain: true,
        url: finalUrl,
        data: XML,
        contentType: "text/xml; charset=utf-8",
        processData: false,
        success: async function (resData) {
          var $doc = $.parseXML(resData);
          var pid = $($doc).find("Data").text();
          var errcode = $($doc).find("Resp").attr("errCode");
          var errinfo = $($doc).find("Resp").attr("errInfo");
          var skey = $($doc).find("Skey").text();
          var ci = parseInt($($doc).find("Skey").attr("ci"));
          var hmac = $($doc).find("Hmac").text();
          var type = $($doc).find("Data").attr("type");
          var dpId = $($doc).find("DeviceInfo").attr("dpId");
          var rdsId = $($doc).find("DeviceInfo").attr("rdsId");
          var rdsVer = $($doc).find("DeviceInfo").attr("rdsVer");
          var dc = $($doc).find("DeviceInfo").attr("dc");
          var mi = $($doc).find("DeviceInfo").attr("mi");
          var mc = $($doc).find("DeviceInfo").attr("mc");
          let data = {
            pid, errcode, errinfo, skey, ci, hmac, type, dpId, rdsId, rdsVer, dc, mi, mc
          };
          try {
            let response = await axios.post('/v2/remittance/customer/ekycenrollment', { ...data, CustomerId: parseInt(kycData?.customer?.CustomerId), PartnerUniqueRefNo: partnerUniqueRefNo, tokenData, CustomerType: CustomerType.value, SourceIncomeType: SourceIncomeType.value, AnnualIncome: AnnualIncome.value });
            const { StatusCode, ResponseMessage } = response.data;
            if (StatusCode == "0") {
              toast(ResponseMessage);
            }
            else {
              toast(ResponseMessage);
            }
          }
          catch (error) {
            if (error?.response?.data?.message) {
              toast(error.response.data.message);
            }
          }
        },
        error: function (jqXHR, ajaxOptions, thrownError) {
          toast(getHttpError(jqXHR));
        },
      });
    } catch (error) {
      toast(getHttpError(error));
    }
  };

  const getHttpError = (error) => {
    let err = "Unhandled Exception";
    if (!error.response) {
      err = 'Service Unavailable';
    } else if (error.response.status === 404) {
      err = 'Requested page not found';
    } else if (error.response.status === 500) {
      err = 'Internal Server Error';
    } else if (error.message === 'timeout') {
      err = 'Time out error';
    } else if (error.message === 'abort') {
      err = 'Ajax request aborted';
    } else {
      err = 'Unhandled Error';
    }
    return err;
  };

  function addSpaceBetweenCases(str) {
    return capitalizeWords(str.replace(/([a-z])([A-Z])/g, '$1 $2')).replaceAll("_", " ");
  }

  function capitalizeWords(string) {
    return string.split(' ').map(word =>
      word.charAt(0).toUpperCase() + word.slice(1)
    ).join(' ')
  }

  const deleteError = (e) => {
    const errorKey = e.target.name;
    if (errorKey) {
      const updatedErrors = { ...errors };
      delete updatedErrors[errorKey];
      setErrors(updatedErrors);
    }
  };

  const getServiceCharge = async (e, serviceData) => {
    deleteError(e);
    let price = e.target.value;
    let requestData = {
      payment_mode: serviceData.PaymentMode,
      transfer_amount: price,
      bank_branch_id: serviceData.BankBranchId,
    };
    try {
      let response = await axios.post('/v2/remittance/get/service/charge', requestData);
      const { status, message, data } = response.data;
      if (status) {
        setCommissionData(data);
      }
      else {
        toast(message);
      }
    }
    catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  const changeData = async (e) => {
    deleteError(e);
    try {
      setReceiverData({ ...receiverData, [e.target.name]: e.target.value });
      if (e.target.name == "payment_mode") {
        setPaymentMode(e.target.value);
      }
      if (e.target.name == "bank") {
        const response = await axios.post('/v2/remittance/get/bank/branch', { bank_name: e.target.value, country: "Nepal" });
        //const response = await axios.post('/v2/remittance/get/banks/prabhu', { bank_name: e.target.value, country: "Nepal" });
        //console.log(response.data);
        const { status } = response.data;
        if (status) {
          setBankBranchName(response.data.banks);
        }
      }
    }
    catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  return (
    <div className="content-wrapper">
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">
                Search Sender (Indo Nepal Money Transfer)
                <Button className="float-right" variant="primary" onClick={handleShow}>
                  Add
                </Button>
              </h4>
              <form className="searchForm" onSubmit={handleSearch}>
                <div className="row">
                  <div className="col-lg-4 col-md-4">
                    <label>Search By</label>
                    <select className="form-control" name="search_by" onChange={(e) => setSearchBy(e.target.value)}>
                      <option value="mobile">Mobile Number</option>
                      <option value="id">ID Number</option>
                    </select>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    {
                      searchBy == "id" ? (
                        <>
                          <label>ID Number</label>
                          <input className="form-control" type="number" name="id_number" required />
                        </>
                      ) : (
                        <>
                          <label>Mobile</label>
                          <input className="form-control" type="number" name="mobile" />
                          <span className="error">{errors && errors?.mobile}</span>
                        </>
                      )
                    }
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <input type="submit" className="search-btn btn btn-primary" value="Search" />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              {
                kycData ? (
                  <>
                    <h4 className="card-title">
                      Sender/Receiver Data
                    </h4>
                    <ul className="showData">
                      <li>
                        <label>Customer ID</label>
                        <div>{kycData?.customer?.CustomerId}</div>
                      </li>
                      <li>
                        <label>Sender Name</label>
                        <div>{kycData?.customer?.Name}</div>
                      </li>
                      <li>
                        <label>Sender Mobile</label>
                        <div>{kycData?.customer?.Mobile.string[0]}</div>
                      </li>
                      <li>
                        <label>Sender DOB</label>
                        <div>{kycData?.customer?.Dob}</div>
                      </li>
                      <li>
                        <label>Sender Gender</label>
                        <div>{kycData?.customer?.Gender}</div>
                      </li>
                      <li>
                        <label>Sender Address</label>
                        <div>{kycData?.customer?.Address}</div>
                      </li>
                      <li>
                        <label>Sender ID Type</label>
                        <div>{kycData?.customer?.Ids?.Id[0]?.IdType}</div>
                      </li>
                      <li>
                        <label>Sender ID Number</label>
                        <div>{kycData?.customer?.Ids?.Id[0]?.IdNumber}</div>
                      </li>
                      <li>
                        <label>Status</label>
                        <div>{kycData?.customer?.OnboardingStatus}</div>
                      </li>
                      <li>
                        <label>EKYC Status</label>
                        <div>{kycData?.customer?.EKYCStatus}</div>
                      </li>
                      <li>
                        <label>Onboarding Status</label>
                        <div>{kycData?.customer?.OnboardingStatus}</div>
                      </li>
                    </ul>
                    <div>
                      {
                        (partnerUniqueRefNo && tokenData) ? (
                          <form onSubmit={captureFinger}>
                            <div className="row justify-content-center">
                              <div className="col-md-12">
                                <div className="row">
                                  <div className="col-lg-3 col-md-3">
                                    <label>Customer Type</label>
                                    <select className="form-control" name="CustomerType" required>
                                      <option value="">--Select--</option>
                                      <option value="1">Salaried</option>
                                      <option value="2">Self Employed including Professional</option>
                                      <option value="3">Farmer</option>
                                      <option value="4">Housewife</option>
                                    </select>
                                  </div>
                                  <div className="col-lg-3 col-md-3">
                                    <label>Source Income Type</label>
                                    <select className="form-control" name="SourceIncomeType" required>
                                      <option value="">--Select--</option>
                                      <option value="1">Govt</option>
                                      <option value="2">Public sector</option>
                                      <option value="3">Private Sector</option>
                                      <option value="4">Business</option>
                                      <option value="5">Agriculture</option>
                                      <option value="6">Dependent</option>
                                    </select>
                                  </div>
                                  <div className="col-lg-3 col-md-3">
                                    <label>Annual Income</label>
                                    <select className="form-control" name="AnnualIncome" required>
                                      <option value="">--Select--</option>
                                      <option value="1">Rs. 0.00 lacs to Rs. 2.00 Lacs</option>
                                      <option value="2">Rs. 2.00 Lacs to Rs. 5 Lacs</option>
                                      <option value="3">Rs. 5 Lacs to Rs. 10 Lacs</option>
                                      <option value="4">More than Rs. 10 Lacs</option>
                                    </select>
                                  </div>
                                  <div className="col-lg-3 col-md-3">
                                    <button className="search-btn btn btn-primary" type="submit">Capture Finger and Onboard</button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </form>
                        ) : (
                          <>
                            <p>KYC is not verified</p>
                            <button className="btn btn-primary" onClick={verifyKyc}>Verify KYC</button>
                          </>
                        )
                      }
                    </div>
                  </>
                ) : (
                  <>
                    {
                      data && (
                        <>
                          <h4 className="card-title">
                            Sender/Receiver Data
                            <Button className="float-right" variant="primary" onClick={(e) => setAddReceiverModal(true)}>
                              Add Receiver
                            </Button>
                          </h4>
                          <div className="col-lg-12 transactionDetail">
                            <div>Total Transactions: {data[0].transactions.Year}</div>
                          </div>
                          <hr />
                          <ul className="showData">
                            {Object.entries(data[0]).map(([key, value]) => (
                              (!['_id', 'created_at', 'updated_at', '__v'].includes(key) && (key == "transactions" || typeof value != 'object') && value != "" && value != null) && (
                                <li key={key}>
                                  <strong>{addSpaceBetweenCases(key)}:</strong>
                                  <div>{key == "transactions" ? value.Year : value}</div>
                                </li>
                              )
                            ))}
                          </ul>
                          <DataTable
                            value={data[0].receivers}
                            size="small"
                            className="custom-table"
                          >
                            <Column
                              field="index"
                              header="#"
                              sortable
                              body={(rowData, { rowIndex }) => <span data-label="#">{rowIndex + 1}</span>}
                            />
                            <Column
                              field="created_at"
                              header="Date"
                              sortable
                              body={(rowData) => <span data-label="Date">{moment(rowData.created_at).format('MMM-DD-YYYY')}<br />{moment(rowData.created_at).format('hh:mm:ss A')}</span>}
                            />
                            <Column
                              field="Name"
                              header="Name"
                              sortable
                              body={(rowData) => <span data-label="Name">{rowData?.Name}</span>}
                            />
                            <Column
                              field="Mobile"
                              header="Mobile"
                              sortable
                              body={(rowData) => <span data-label="Mobile">{rowData.Mobile}</span>}
                            />
                            <Column
                              field="PaymentMode"
                              header="Payment Mode"
                              sortable
                              body={(rowData) => <span data-label="PaymentMode">{rowData?.PaymentMode}</span>}
                            />
                            <Column
                              field="Gender"
                              header="Gender"
                              sortable
                              body={(rowData) => <span data-label="Gender">{rowData.Gender}</span>}
                            />
                            <Column
                              field="Address"
                              header="Address"
                              sortable
                              body={(rowData) => <span data-label="Address">{rowData.Address}</span>}
                            />
                            <Column
                              field="Relationship"
                              header="Relationship"
                              sortable
                              body={(rowData) => <span data-label="Relationship">{rowData.Relationship}</span>}
                            />
                            <Column
                              field="BankName"
                              header="Bank Name"
                              sortable
                              body={(rowData) => <span data-label="BankName">{rowData.BankName}</span>}
                            />
                            <Column
                              field="AcNumber"
                              header="Account Number"
                              sortable
                              body={(rowData) => <span data-label="AccountNumber">{rowData.AcNumber}</span>}
                            />
                            <Column
                              field="action"
                              header="Action"
                              sortable
                              body={
                                (rowData, { rowIndex }) => (
                                  <span data-label="Action">
                                    <button className="btn btn-primary" onClick={() => handleViewData(rowIndex)}>Send</button>
                                  </span>
                                )
                              }
                            />
                          </DataTable>
                        </>
                      )
                    }
                  </>
                )
              }
            </div>
          </div>
        </div>
      </div>
      <Modal show={showModal} onHide={handleClose} centered size={processId == "" ? 'xl' : 'sm'} backdrop="static">
        <Form onSubmit={handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Create New Sender</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {
              processId == "" ? (
                <div className="row justify-content-center">
                  <div className="col-md-12">
                    <div className="row">
                      <div className="col-lg-4 col-md-4">
                        <label>Name</label>
                        <input className="form-control" type="text" name="name" onChange={deleteError} requiredField="true" />
                        <span className="error">{errors && errors?.name}</span>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label>Gender</label>
                        <select className="form-control" name="gender" onChange={deleteError} requiredField="true">
                          <option value="">Select Gender</option>
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                          <option value="Other">Other</option>
                        </select>
                        <span className="error">{errors && errors?.gender}</span>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label>Date of birth</label>
                        <input className="form-control" type="date" name="date_of_birth" onChange={deleteError} requiredField="true" />
                        <span className="error">{errors && errors?.date_of_birth}</span>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label>Address</label>
                        <input className="form-control" type="text" name="address" onChange={deleteError} requiredField="true" />
                        <span className="error">{errors && errors?.address}</span>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label>Mobile</label>
                        <input className="form-control" type="number" name="mobile" onChange={deleteError} requiredField="true" />
                        <span className="error">{errors && errors?.mobile}</span>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label>Country</label>
                        <select className="form-control" name="country" onChange={getStateData} requiredField="true">
                          <option value="">Select Country</option>
                          <option value="India">India</option>
                          <option value="Nepal">Nepal</option>
                        </select>
                        <span className="error">{errors && errors?.country}</span>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label>State</label>
                        <select className="form-control" name="state" onChange={getDistrictData} requiredField="true">
                          <option value="">--State--</option>
                          {states && states.map((state, index) => (
                            <option value={state}>
                              {state}
                            </option>
                          ))}
                        </select>
                        <span className="error">{errors && errors?.state}</span>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label>District</label>
                        <select className="form-control" name="district" onChange={deleteError} requiredField="true">
                          <option value="">Select District</option>
                          {districts && districts.map((district, index) => (
                            <option value={district}>
                              {district}
                            </option>
                          ))}
                        </select>
                        <span className="error">{errors && errors?.district}</span>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label>City</label>
                        <input className="form-control" type="text" name="city" onChange={deleteError} requiredField="true" />
                        <span className="error">{errors && errors?.city}</span>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label>Employer</label>
                        <select className="form-control" name="employer" onChange={deleteError} requiredField="true">
                          <option value="">--Select--</option>
                          <option value="Self">Self</option>
                          <option value="Salaried">Salaried</option>
                        </select>
                        <span className="error">{errors && errors?.employer}</span>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label>Id Type</label>
                        <select className="form-control" name="id_type" onChange={deleteError} requiredField="true">
                          <option value="">Select Id Type</option>
                          <option value="Aadhaar Card">Aadhaar Card</option>
                          <option value="Indian Driving License">Indian Driving License</option>
                          <option value="Nepalese Passport">Nepalese Passport</option>
                          <option value="Pan Card">Pan Card</option>
                        </select>
                        <span className="error">{errors && errors?.id_type}</span>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label>Id Number</label>
                        <input className="form-control" type="number" name="id_number" onChange={deleteError} requiredField="true" />
                        <span className="error">{errors && errors?.id_number}</span>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label>Income Source</label>
                        <select className="form-control" name="income_source" onChange={deleteError} requiredField="true">
                          <option value="">--Select--</option>
                          <option value="Business">Business</option>
                          <option value="Gift">Gift</option>
                          <option value="Lotery">Lotery</option>
                          <option value="Salary">Salary</option>
                          <option value="Saving">Saving</option>
                          <option value="Other">Other</option>
                        </select>
                        <span className="error">{errors && errors?.income_source}</span>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="row justify-content-center">
                  <div className="col-md-12">
                    <div className="row">
                      <div className="col-lg-12 col-md-12">
                        <label>OTP</label>
                        <input className="form-control" type="number" name="otp" onChange={deleteError} requiredField="true" />
                        <span className="error">{errors && errors?.otp}</span>
                      </div>
                    </div>
                  </div>
                </div>
              )
            }
          </Modal.Body>
          <Modal.Footer>
            <Button type="submit" variant="primary">
              {processId == "" ? 'Send OTP' : 'Create Customer'}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
      <Modal show={viewData} onHide={handleClose} centered size='xl' backdrop="static">
        <Form onSubmit={transferAmountSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Receiver Data</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {
              (data && data[0].receivers) && (
                <>
                  <ul className="showData">
                    {Object.entries(data[0].receivers[viewIndex]).map(([key, value]) => (
                      (value != "" && value != null) && (
                        <li key={key}>
                          <strong>{addSpaceBetweenCases(key)}:</strong>
                          <div>{value}</div>
                        </li>
                      )
                    ))}
                    <li>
                      <strong>Transfer Amount (₹):</strong>
                      <div><input className="form-control" type="number" name="transferAmount" onChange={(e) => getServiceCharge(e, data[0].receivers[viewIndex])} max="50000" required /></div>
                    </li>
                    <li>
                      <strong>Remittance Reason:</strong>
                      <div>
                        <select className="form-control" name="remittanceReason" required>
                          <option value="">--Select--</option>
                          <option value="Family Maintenance">Family Maintenance</option>
                          <option value="Medical Expenses">Medical Expenses</option>
                        </select>
                      </div>
                    </li>
                    {
                      commissionData && (
                        <>
                          <li>
                            <strong>PayOut Amount:</strong>
                            <div>{commissionData.PayoutAmount} {commissionData.PayoutCurrency}</div>
                          </li>
                          <li>
                            <strong>Exchange Rate:</strong>
                            <div>{commissionData.ExchangeRate}</div>
                          </li>
                          <li>
                            <strong>Service Charge:</strong>
                            <div>{commissionData.ServiceCharge}</div>
                          </li>
                          <li>
                            <strong>Collection Amount:</strong>
                            <div>{commissionData.CollectionAmount} {commissionData.CollectionCurrency}</div>
                          </li>
                        </>
                      )
                    }
                    {
                      (processId != "") ? (
                        <li>
                          <strong>OTP:</strong>
                          <div><input className="form-control" type="number" name="otp" required /></div>
                        </li>
                      ) : (
                        <li></li>
                      )
                    }
                  </ul>
                </>
              )
            }
          </Modal.Body>
          <Modal.Footer>
            <Button type="submit" variant="primary">
              {processId == "" ? 'Send OTP' : 'Transfer'}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
      <Modal show={addReceiverModal} onHide={handleClose} centered size={processId == "" ? 'xl' : 'sm'} backdrop="static">
        <Form onSubmit={addReceiverSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Add Receiver</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {
              processId == "" ? (
                <div className="row justify-content-center">
                  <div className="col-md-12">
                    <div className="row">
                      <div className="col-lg-4 col-md-4">
                        <label>Name</label>
                        <input className="form-control" type="text" name="receiver_name" value={receiverData?.receiver_name} onChange={changeData} requiredField="true" />
                        <span className="error">{errors && errors?.receiver_name}</span>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label>Gender</label>
                        <select className="form-control" name="receiver_gender" value={receiverData?.receiver_gender} onChange={changeData} requiredField="true">
                          <option value="">Select Gender</option>
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                          <option value="Other">Other</option>
                        </select>
                        <span className="error">{errors && errors?.receiver_gender}</span>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label>Mobile Number</label>
                        <input className="form-control" type="number" name="receiver_mobile" value={receiverData?.receiver_mobile} onChange={changeData} requiredField="true" />
                        <span className="error">{errors && errors?.receiver_mobile}</span>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label>Relationship</label>
                        <select className="form-control" name="relationship" value={receiverData?.relationship} onChange={changeData} requiredField="true">
                          <option value="">--Select--</option>
                          <option value="Aunti">Aunti</option>
                          <option value="Boy Friend">Boy Friend</option>
                          <option value="Brother">Brother</option>
                          <option value="Brother in Law">Brother in Law</option>
                          <option value="Cousin">Cousin</option>
                          <option value="Daughter">Daughter</option>
                          <option value="Father">Father</option>
                          <option value="Father in Law">Father in Law</option>
                          <option value="Friend">Friend</option>
                          <option value="Girl Friend">Girl Friend</option>
                          <option value="Grand Father">Grand Father</option>
                          <option value="Grand Monther">Grand Monther</option>
                          <option value="Husband">Husband</option>
                          <option value="Mother">Mother</option>
                          <option value="Mother in Law">Mother in Law</option>
                          <option value="Nephew">Nephew</option>
                          <option value="Niece">Niece</option>
                          <option value="Self">Self</option>
                          <option value="Sister">Sister</option>
                          <option value="Sister in Law">Sister in Law</option>
                          <option value="Son">Son</option>
                          <option value="Uncle">Uncle</option>
                          <option value="Wife">Wife</option>
                          <option value="Other">Other</option>
                        </select>
                        <span className="error">{errors && errors?.relationship}</span>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label>Address</label>
                        <input className="form-control" type="text" name="receiver_address" value={receiverData?.receiver_address} onChange={changeData} requiredField="true" />
                        <span className="error">{errors && errors?.receiver_address}</span>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label>Payment Mode</label>
                        <select className="form-control" name="payment_mode" value={receiverData?.payment_mode} onChange={changeData} requiredField="true">
                          <option value="">--Select--</option>
                          <option value="Account Deposit">Account Deposit</option>
                          <option value="Cash Payment">Cash Payment</option>
                        </select>
                        <span className="error">{errors && errors?.payment_mode}</span>
                      </div>
                      {
                        (paymentMode && paymentMode == "Account Deposit") && (
                          <>
                            <div className="col-lg-4 col-md-4">
                              <label>Bank</label>
                              <select className="form-control" name="bank" value={receiverData?.bank} onChange={changeData} requiredField="true">
                                <option value="">--Select--</option>
                                {
                                  bankName && bankName.map((data, index) => (
                                    <>
                                      <option value={data}>{data}</option>
                                    </>
                                  ))
                                }
                              </select>
                              <span className="error">{errors && errors?.bank}</span>
                            </div>
                            <div className="col-lg-4 col-md-4">
                              <label>Bank Branch</label>
                              <select className="form-control" name="bank_branch_id" value={receiverData?.bank_branch_id} onChange={changeData} requiredField="true">
                                <option value="">--Select--</option>
                                {
                                  bankBranchName && bankBranchName.map((data, index) => (
                                    <>
                                      <option value={data.BankBranchId}>{data.BranchName}</option>
                                    </>
                                  ))
                                }
                              </select>
                              <span className="error">{errors && errors?.bank_branch_id}</span>
                            </div>
                            <div className="col-lg-4 col-md-4">
                              <label>Account Number</label>
                              <input className="form-control" type="text" name="account_number" value={receiverData?.account_number} onChange={changeData} requiredField="true" />
                              <span className="error">{errors && errors?.account_number}</span>
                            </div>
                          </>
                        )
                      }
                    </div>
                  </div>
                </div>
              ) : (
                <div className="row justify-content-center">
                  <div className="col-md-12">
                    <div className="row">
                      <div className="col-lg-12 col-md-12">
                        <label>OTP</label>
                        <input className="form-control" type="number" name="otp" onChange={deleteError} requiredField="true" />
                      </div>
                    </div>
                  </div>
                </div>
              )
            }
          </Modal.Body>
          <Modal.Footer>
            <Button type="submit" variant="primary">
              {processId == "" ? 'Send OTP' : 'Create Receiver'}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </div>
  );
}

export default IndoNepalMoneyTransfer;
